<template>
  <div class="row">
    <div class="col-12">
        <div class="card card-body">
            <h5>
                كشوف المتابعة الواردة من المعلمين
            </h5>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-sm">
                    <thead>
                        <th>
                            المعلم
                        </th>
                        <th>
                            المادة
                        </th>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            تم رؤيتها
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="k in kushof" :key="k._id" :class="k.seen ? '' : 'bg-light-warning'">
                            <td>
                                {{ k.teacher_name }}
                            </td>
                            <td>
                                {{ k.subject }}
                            </td>
                            <td>
                                {{ k.date }}
                            </td>
                            <td>
                                <span v-if="k.seen">نعم</span>
                                <span v-if="!k.seen" class="text-danger">لا</span>
                            </td>
                            <td style="padding: 0px">
                                <button class="btn btn-sm btn-primary" @click="view(k)" style="padding: 5px">
                                    <i class="fa fa-eye"></i>
                                    عرض / طباعة
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem('user')),
            kushof: []
        }
    },
    created(){
        if(!checkPer("mentors")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.get()
    },
    methods: {
        get(){
            var g = this;
            $.post(api + '/user/mentors/kushof-teachers', {
                jwt: this.user.jwt
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    g.kushof = r.response;
                }
            }).fail(function(){
            })
        },
        view(k){
            var g = this;
            if(!k.seen){
                $.post(api + '/user/mentors/kushof-teachers-seen', {
                    jwt: this.user.jwt,
                    id: k._id
                }).then(function(r){
                    g.loading = false
                    if(r.status != 100){
                        alert(r.response)
                    }else{
                        g.get()
                    }
                }).fail(function(){
                })
            }
            var newWindow = window.open("", "_blank");
            var newDoc = newWindow.document;
            newDoc.write("<!DOCTYPE html>");
            newDoc.write("<html dir='rtl'>");
            newDoc.write("<head>");
            newDoc.write(`
            <style>
        @font-face {
            font-family: 'myFirstFont';
            src: url("/calibril.ttf");
        }

        table,
        td,
        th {
            border: 1px solid;
            padding: 1px !important
        }

        table {
            width: 100%;
            border-collapse: collapse;
        }

        * {
            font-family: "myFirstFont" !important;
            font-weight: normal !important;
            white-space: nowrap;
        }

        .content {
            position: relative;
            top: -120px;
            width: 90%;
            margin: 0px auto;
        }

        .copy {
            position: absolute;
            z-index: 999;
            top: 0px;
            left: 0px;
        }

        button {
            border: 2px solid #4CAF50;
            /* Green */
            padding: 0px;
            text-align: center;
            text-decoration: none;
            display: inline-block;
            font-size: 20px;
            margin: 4px 2px;
            transition-duration: 0.4s;
            cursor: pointer;
            width: 100px;
            background-color: #4CAF50;
            color: white;
        }
        .print {
            position: absolute;
            top: 100px;
            left: 0px;
            z-index: 9999 !important;
        }
        .forward button {
            position: absolute;
            top: 150px;
            left: 0px;
            width: 120px;
            background: #799EFF !important;
            z-index: 9999 !important;
        }


        button:hover {
            background-color: #ff05c9;
            /* Green */
            color: white;
        }

        .content img {
            position: absolute;
            top: 0px;
            max-height: 80vh
        }

        @media  print {
            .print {
                display: none
            }
            button {
                display: none
            }
        }

        @page  {
            margin: 0px;
            padding: 0px
        }
    </style>`);
            newDoc.write("<title>tahdir.net</title><style>button{display: none !important}</style>");
            newDoc.write("</head>");
            newDoc.write("<body>");
            newDoc.write(k.content);
            newDoc.write("</body>");
            newDoc.write("</html>");
            
            newDoc.close();
            setTimeout(() => {
                newWindow.print();
            }, 1000);
        }
    }
}
</script>

<style>

</style>